<template>
  <div
    class="grid transition-[grid-template-rows] duration-300 ease-in-out"
    :class="expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
  >
    <div class="overflow-hidden">
      <div
        :aria-hidden="!expanded"
        class="transition-opacity duration-300"
        :class="expanded ? 'opacity-100' : 'opacity-0'"
        :inert="!expanded"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ expanded: boolean }>()
</script>
